// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3kfRF","upload":"Small_upload__24vXH","imageWrap":"Small_imageWrap__33Q8V","removeBtn":"Small_removeBtn__3afEO"};